import React from 'react';
import styles from './ChatPanel.module.css';
import type { ChatPanelSlashSuggestion } from './chatPanelSlashSuggestions';

export interface ChatPanelSlashMenuProps {
  suggestions: ChatPanelSlashSuggestion[];
  onPick: (command: string) => void;
}

export const ChatPanelSlashMenu: React.FC<ChatPanelSlashMenuProps> = ({
  suggestions,
  onPick,
}) => {
  if (suggestions.length === 0) return null;
  return (
    <ul className={styles.slashMenu} data-testid="chat-slash-menu" role="listbox" aria-label="Slash commands">
      {suggestions.map((row) => (
        <li key={row.command}>
          <button
            type="button"
            className={styles.slashMenuItem}
            role="option"
            onMouseDown={(e) => {
              e.preventDefault();
              onPick(row.command);
            }}
          >
            <span className={styles.slashMenuCommand}>/{row.command}</span>
            <span className={styles.slashMenuDescription}>{row.description}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};
